import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import './swRegistration';
import App from './App.tsx';
import './index.css';
import { OnlineRealtimeGuard } from './components/OnlineRealtimeGuard.tsx';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <OnlineRealtimeGuard>
        <App />
      </OnlineRealtimeGuard>
    </ErrorBoundary>
  </StrictMode>,
);
